import React, { useMemo } from 'react'
import { UnknownRecord } from 'types/global'
import styled from 'styled-components'

import { AppColors } from 'utils/colors'

type ColorKey = keyof AppColors

type Props = {
  content: UnknownRecord
  bgColor?: ColorKey
  textColor?: ColorKey
  indentation?: number | '\t'
}

const JsonPresenter: React.FC<Props> = ({ content, bgColor, textColor, indentation = '\t' }) => {
  const formattedContent = useMemo(() => {
    try {
      return JSON.stringify(content, null, indentation)
    } catch (e) {
      console.error('invalid json content')
      return ''
    }
  }, [content, indentation])

  return (
    <Container bgColor={bgColor}>
      <StyledPre textColor={textColor}>{formattedContent}</StyledPre>
    </Container>
  )
}

export default JsonPresenter

const Container = styled.div<{ bgColor?: ColorKey }>`
  background-color: ${(p) => (p.bgColor ? p.theme.colors[p.bgColor] : p.theme.colors.gray7)};
  padding: 16px 24px;
`

const StyledPre = styled.pre<{ textColor?: ColorKey }>`
  color: ${(p) => (p.textColor ? p.theme.colors[p.textColor] : p.theme.colors.green)};
`
